import React, { useEffect, useState } from "react";
import { Marker } from "react-leaflet";
import { guide } from "../Icons/icons";
import useLeaflet from "../hooks/useLeaflet";
import L from "leaflet";
import guideAreaRaw from "./guideArea.json";
import Axios from "axios";

export type Guide = {
  description: {
    da: string;
    de: string;
    en: string;
  };
  openingHours: {
    da: string;
    de: string;
    en: string;
  };
  position: {
    lat: number;
    lng: number;
  };
  name: string;
  email: string;
  phone: string;
  url: string;
  imageUrl: string;
  areas: string;
  boat: boolean;
};

/*
 * This component displays the fishing guide markers on the map
 */

const FishingGuides = (props: { onClick: (guide: Guide) => void }) => {
  const [guides, setGuides] = useState<Guide[]>([]);

  useEffect(() => {
    Axios.get<Guide[]>("https://www.limfjordsraadet.dk/data/guider/")
      .then((res) => {
        setGuides(res.data || []);
      })
      .catch((error) => {
        console.log(error);
        setGuides([]);
      });
  }, []);

  const guideMarkers =
    guides &&
    Array.isArray(guides) &&
    guides.map((x, i) => (
      <Marker
        key={i}
        position={{ lat: x.position.lat, lng: x.position.lng }}
        onclick={() => props.onClick(x)}
        icon={guide}
        zIndexOffset={1000}
      />
    ));

  return <div>{guideMarkers}</div>;
};

export default FishingGuides;

export const useFishingAreas = (areaNumbers: number[]) => {
  const context = useLeaflet();
  useEffect(() => {
    if (!context) return;
    const guideAreaData: any = guideAreaRaw;
    const guideAreaDataFiltered = {
      ...guideAreaData,
      features: guideAreaData.features.filter((x: any) =>
        areaNumbers.includes(x.properties.Id)
      ),
    };
    const geoJsonLayer = L.geoJSON(guideAreaDataFiltered, {
      style: function(feature) {
        return {
          fillColor: "#333", // Color of the polygon fill
          fillOpacity: 0.33, // This makes the fill transparent
          weight: 0, // Width of the polygon border
        };
      },
    }).addTo(context.map);

    return () => context.map.removeLayer(geoJsonLayer);
  }, [context.map]);

  return null;
};
